import React, { FC, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";
import { EpgEventDetailOverride } from "../../../../../models/epg/Models";

interface ListInputFieldProps<K extends keyof EpgEventDetailOverride> {
    label: string;
    items: string[];
    isEditMode: boolean;
    fieldName: K;
    updateField: <K extends keyof EpgEventDetailOverride>(key: K, value: EpgEventDetailOverride[K]) => void;
}

const ListInputField: FC<ListInputFieldProps<keyof EpgEventDetailOverride>> = (
    { label, items, isEditMode, fieldName, updateField }: ListInputFieldProps<keyof EpgEventDetailOverride>) => {
    const [ value, setValue ] = useState("");

    const removeItem = (index: number) => {
        const newItems = [ ...items ];
        newItems.splice(index, 1);

        updateField(fieldName, newItems);
    };

    const addItem = () => {
        const newItems = items ? [ ...items ] : [];
        newItems.push(value);
        updateField(fieldName, newItems);
        setValue("");
    };

    return (
        <>
            <p className = {"text-slate-500 font-bold text-lg mb-2"}>{label}</p>
            <div className = {`w-full`}>
                <div className = {`flex items-center gap-2 mb-2 ${isEditMode ? "block" : "hidden"}`}>
                    <input className = {`p-2 w-full bg-light rounded-md ${isEditMode ? "text-gray-800" : ""}`} value = {value}
                           type = {"text"} disabled = {!isEditMode} placeholder = {`Add an item`}
                           onChange = {(e) => {
                               const value = e.target.value;
                               setValue(value);
                           }}
                    />
                    <button
                        className = {`flex flex-row items-center gap-2 bg-blue-800 dark:bg-indigo-400 rounded-md shadow-xl p-2`}
                        onClick={() => {
                            addItem();
                        }}
                    >
                        <FontAwesomeIcon icon = {faPlus} size = "1x" fixedWidth className={`text-white`} />
                    </button>
                </div>
                {
                    items && items.length > 0 ?
                        (<div className = {`flex flex-row gap-2 mt-2`}>
                            {
                                items.map((item, index) => (
                                    <div key = {item}
                                         className = {`flex flex-row gap-1 items-center justify-center shadow-md border p-1 rounded-md bg-blue-800 dark:bg-indigo-400`}
                                    >
                                        <p className={`text-white`}>{item}</p>
                                        <button
                                            className = {`${isEditMode ? "block" : "hidden"}`}
                                            onClick = {() => {
                                                removeItem(index);
                                            }}
                                        >
                                            <FontAwesomeIcon icon = {faXmark} size = "sm" fixedWidth className={`text-white`} />
                                        </button>
                                    </div>
                                ))}
                         </div>) :
                        <div className = {`p-4 ${isEditMode ? "hidden" : "block"}`}>
                            <p className = {`font-bold text-slate-500`}>
                                {`No ${label} added yet`}
                            </p>
                        </div>
                }
            </div>
        </>);
};

export default ListInputField;